import { Fragment } from "react";
import { Container } from "@/components/container";
import {
  Toolbar,
  ToolbarHeading,
  ToolbarDescription,
  ToolbarPageTitle,
} from "@/partials/toolbar";
import { PageNavbar } from "@/pages/account";
import { useLayout } from "@/providers";
import { HarborDeletionListings } from "./HarborDeletionListings";
import { BackButton } from "@/components/button";

const HarborDeletionManagement = () => {
  const { currentLayout } = useLayout();

  return (
    <Fragment>
      <PageNavbar />

      {currentLayout?.name === "demo1-layout" && (
        <Container>
          <Toolbar>
            <ToolbarHeading>
              <div className="flex items-center gap-3">
                <BackButton customBackPath="/habor-management" />
                <div>
                  <ToolbarPageTitle text="Harbor Deletion Requests" />
                  <ToolbarDescription>
                    Review and manage harbor deletion requests here.
                  </ToolbarDescription>
                </div>
              </div>
            </ToolbarHeading>
          </Toolbar>

          <div className="mt-6">
            <HarborDeletionListings />
          </div>
        </Container>
      )}
    </Fragment>
  );
};

export { HarborDeletionManagement };
